// Prototype role model. Roles drive which actions are VISIBLE (hidden actions
// are preferred over disabled ones) and which surfaces can be edited. This is a
// mock authorization layer, not a real one.

export const ROLE = {
  INITIATOR: 'Initiator',
  CHANGE_MANAGER: 'Change manager',
  QUALITY_ASSURANCE: 'Quality assurance',
  REGULATORY_AFFAIRS: 'Regulatory affairs',
  SYSTEM_ADMINISTRATOR: 'System administrator',
  READ_ONLY_AUDITOR: 'Read-only auditor',
} as const;
export type TRole = (typeof ROLE)[keyof typeof ROLE];

export const ROLE_OPTIONS: { value: TRole; description: string }[] = [
  { value: ROLE.INITIATOR, description: 'Creates and edits a draft or returned request.' },
  { value: ROLE.CHANGE_MANAGER, description: 'Owns submitted changes and coordinates their assessment.' },
  { value: ROLE.QUALITY_ASSURANCE, description: 'Oversees change risk and controlled implementation.' },
  { value: ROLE.REGULATORY_AFFAIRS, description: 'Views and comments on relevant changes.' },
  { value: ROLE.SYSTEM_ADMINISTRATOR, description: 'Sees all prototype controls.' },
  { value: ROLE.READ_ONLY_AUDITOR, description: 'Read-only across the whole record.' },
];

// Roles that may triage a submitted request.
export const TRIAGE_ROLES: TRole[] = [ROLE.CHANGE_MANAGER, ROLE.QUALITY_ASSURANCE, ROLE.SYSTEM_ADMINISTRATOR];

// Roles that can never write anything.
export const READ_ONLY_ROLES: TRole[] = [ROLE.READ_ONLY_AUDITOR];
